<template>
  <section id="admin-filter">
    <h4>Vendor zone filter</h4>
    <div class="form-group">
      <label class="form-label">Vendor</label>
      <autocomplete
        :dataset="partySearchResults"
        title="Vendor"
        placeHolder="Type to search"
        :initVal="entity.vendor"
        v-on:changing="data => partySearchText = data"
        :fnFormatText="displayParty"
        :fnSelectValue="displayParty"
        v-on:selection-made="selectVendor"
      ></autocomplete>
    </div>
    <div class="form-group">
      <label class="form-label">Name</label>
      <autocomplete
        :dataset="locationSearchResults"
        title="Name"
        placeHolder="Type to search"
        :initVal="entity.location"
        v-on:changing="data => locationSearchText = data"
        :fnFormatText="displayLocation"
        :fnSelectValue="displayLocation"
        v-on:selection-made="selectLocation"
      ></autocomplete>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  export default {
    name: 'VendorZoneFilter',
    mixins: [ FilterMixin, HelperMixin ],
    data () {
      return {
        entity: {
          vendor: '',
          location: {}
        }
      }
    },
    components: {
      Autocomplete
    },
    methods: {
      selectVendor (v) {
        this.entity.vendor = v
        this.partySearchText = ''
        this.partySearchResults = []
      },
      selectLocation (d) {
        this.entity.location = d
        this.locationSearchText = ''
        this.locationSearchResults = []
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// VendorZoneFilter.vue?d24cb43a